import * as React from "react";
import { ListItem, ListItemIcon, ListItemText, Theme, createStyles } from "@material-ui/core";
import PowerIcon from "@material-ui/icons/PowerSettingsNew";
import { withStyles, WithStyles } from "@material-ui/core/styles";

interface LogoutListItemButtonProps extends WithStyles<typeof styles> {
  onLogout: () => void;
}

class LogoutListItemButton extends React.PureComponent<LogoutListItemButtonProps> {
  logout = () => {
    this.props.onLogout();
  };

  render() {
    const { classes } = this.props;
    return (
      <ListItem classes={{ root: classes.listItemRoot }} button={true} onClick={this.logout}>
        <ListItemIcon>
          <PowerIcon />
        </ListItemIcon>
        <ListItemText primary="Logout" />
      </ListItem>
    );
  }
}

const styles = (theme: Theme) =>
  createStyles({
    listItemRoot: {
      borderRadius: 0,
      boxShadow: "none",
      marginTop: 0
    }
  });

export default withStyles(styles)(LogoutListItemButton);
